import React from 'react';
import {sendEvarData, logPageLoadEvents} from '@ibibo/analytics';
import FileLoader from '../FileUploader/FileUploader';

import * as S from './UploadedFiles.styles';

const UploadedFiles = ({
  onApprove,
  fileType,
  fileTypes,
  filePath,
  onFileSelect,
  getFileInfo,
  disableSubmitButton,
}) => {
  const uploadAgain = () => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:businessdetails|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/upload-license',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_uploadAgain',
    });
  };

  return (
    <S.UpldsFiles>
      <S.UploadedFilesBody>
        {(fileType === 'image/png' || fileType === 'image/jpeg' || fileType === 'image/jpg') && (
          <img src={filePath} alt="" />
        )}
        {fileType === 'application/pdf' && <embed src={filePath} type="application/pdf" />}
      </S.UploadedFilesBody>
      <S.UploadedFilesFtr>
        <span className="font10 latoBlack greyText noShrink">UPLOAD - PREVIEW</span>
        <div className="makeFlex hrtlCenter">
          <FileLoader
            fileTypes={fileTypes}
            onFileSelect={onFileSelect}
            getFileInfo={getFileInfo}
            width={80}
            height={16}
            textOnly={true}
            bgColor="#252525"
          >
            <p className="font12 blueText" onClick={uploadAgain}>
              Upload Again
            </p>
          </FileLoader>
          <S.BtnApprove onClick={onApprove} isDisabled={disableSubmitButton}>
            Approve
          </S.BtnApprove>
        </div>
      </S.UploadedFilesFtr>
      <p className="padding10 font10 latoBlack greyText">
        By clicking on the 'APPROVE' button, you agree and accept that all your personal information
        (including the sensitive personal information) shall be governed as per the Privacy Policy
        and shall be stored in the servers located in territory of India owned, controlled and
        managed by MakeMyTrip (India) Private Limited, which is an entity of the MakeMyTrip Group.
      </p>
    </S.UpldsFiles>
  );
};

export default UploadedFiles;
